// Module
var code = `<div class="js-product-main-body">
    <div class="js-products-body">

        <div class="js-products-switch-menu" >
            <div class="js-products-switch-item" {{#.checkedCategories}}checked{{/}} on-click="['clickCheck', 'Categories']"  as-tooltip="categoriesTextToolTip">
                {{categoriesText + '' + categoriesTextNum}}
            </div>
            <div class="js-products-switch-item" {{#.checkedRequest}}checked{{/}} on-click="['clickCheck', 'Request']"  as-tooltip="requestTextToolTip">
            {{.requestText}}
            </div>
        </div>
    
        <div class="js-products-products-main-toolbarPanel" style="display: {{checkedCategories?'flex':'none'}};">
            <terceraComboBox additionalClass="combobox-size" name="filterComboBox" showLastValue="true" on-ValueChange="onSelectedFilterValueChange"/>
        </div>
    
        {{#if .checkedCategories}}

            {{#if noData}}
                {{>noDataPart}}
            {{/if}}

        <div class="js-products-main" style="height:{{.heightSubscriptionsPanel}}px;">
            <div class="products-list">
                {{#each categories: k}}
                <div class="js-products-category" style="display: {{categories[k].Array.length?'flex':'none'}};" id="{{categories[k].Name}}">
                    <div class="js-products-category-header{{categories[k].IsHide ? '' : ' open'}}" on-click="['onCollapserClick', categories[k].Name]">
                        <svg>
                            <use xlink:href="assets/webdesktop/web-desktop-sprite.svg#ArrowDown"></use>
                        </svg>
                        {{#if categories[k].HasCategoryName()}}
                            {{categories[k].Name}}
                        {{/if}}
                        {{' (' + categories[k].Array.length + ')'}}
                    </div>
                    <div class="products-category-body" style="display: {{categories[k].IsHide ? 'none' : 'flex'}};">
                        {{#if categories[k].startIndex}}
                            <div class="js-scrolling-left" on-click="['scrolling_left_Click', categories[k].Name]">
                                <svg>
                                    <use xlink:href="assets/webdesktop/web-desktop-sprite.svg#ArrowLeft"></use>
                                </svg>
                            </div>
                        {{/if}}
                        <div class="js-products-category-item">
                            {{#each categories[k].VisibleArray: item}}
                                <productsComponent propertiesProduct="{{categories[k].VisibleArray[item]}}"/>
                            {{/each}} 
                        </div>
                        {{#if categories[k].endIndex < categories[k].Array.length}}
                            <div class="js-scrolling-right" on-click="['scrolling_right_Click', categories[k].Name]">
                                <svg>
                                    <use xlink:href="assets/webdesktop/web-desktop-sprite.svg#ArrowRight"></use>
                                </svg>
                            </div>
                        {{/if}}
                    </div>
                </div>
                {{/each}}
            </div>
        </div>
        {{/if}}
    
        <div class="js-products-request-topPanel">
            <rangeSelectPanel name='productPanelRangeSelect' />
        </div>
    </div>
    <div class="js-tercera-panel-main">        
        <terceraPanel name="windowPanelBodyQT" />
    </div>
</div>
`;
// Exports
export default code;